var map = {
	"./README.md": 89767,
	"./dao_create.png": 52091,
	"./dao_description.png": 86329,
	"./dao_how_to_create_a_proposal_on_tezos.png": 16071,
	"./dao_select_template.png": 96118,
	"./dao_settings.png": 83184,
	"./how_to_create_dao_on_tezos.png": 54538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47758;